<template>
    <div :class="['borderModal', seeType == 'tishi' ? 'RewardModal' : '']">
        <img class="closed" @click="() => {
            $emit('closeModal')
        }" src="../../../assets/imgs/public/close.png" alt="" />
        <!-- <img class="bg" src="@/assets/imgs/chidrenDay/seeBg.png" alt=""> -->
        <div class="RankBody p" v-if="seeType == 'Ranking'">
            <div class="signIn_mode">
                <div class="mode_item" :class="{ active: modeType === 'COUPLE' }" @click="switchMode('COUPLE')">
                    情侣模式
                </div>
                <div class="mode_item" :class="{ active: modeType === 'SISTER' }" @click="switchMode('SISTER')">
                    闺蜜模式
                </div>
            </div>
            <div class="tit">
                <div class="rank">名次</div>
                <div class="name">角色昵称</div>
                <div class="num" v-if="modeType === 'COUPLE'">累计情侣红心</div>
                <div class="num" v-else>累计蜜糖之心</div>
            </div>
            <div class="items">
                <div class="itemList" v-for="(value, index) in infoData" :key="index">
                    <div class="rank">{{ value.rank }}</div>
                    <div class="name" :title="value.usernick">{{ value.usernick }}</div>
                    <div class="num">{{ value.family }}</div>
                    <!-- <div class="num">{{ value.exchangeTotal }}</div> -->
                </div>
            </div>
        </div>
        <div class="hit" v-if="seeType == 'Ranking'">10分钟刷新一次,仅显示前10名</div>
        <!-- 记录 -->
        <div class="Record p" v-if="seeType == 'Record'">
            <div class="tit">
                <div class="rank">等级</div>
                <div class="name">奖品</div>
                <!-- <div class="num">奖励</div> -->
                <div class="num">数量</div>
            </div>
            <div class="items">
                <div class="itemList" v-for="(value, index) in RecordList" :key="index">
                    <div class="rank">{{ value.level }}</div>
                    <div class="name" :title="value.name">{{ value.name }}</div>
                    <!-- <div class="num">{{ value.prizeNo }}</div> -->
                    <div class="num">{{ value.quantity }}</div>
                </div>
            </div>
            <div class="Record_btn">
                <el-pagination background :hide-on-single-page="true" :page-size='10' :total="total"
                    layout="prev, pager, next" @current-change="pagination_change">
                </el-pagination>
            </div>
        </div>
        <!-- 规则 -->
        <!-- 规则弹窗/区域 -->
        <div class="Rules p" v-if="seeType == 'Rules'">
            <!-- 1. 活动时间 -->
            <div class="time-card">
                <span class="clock-icon">🕒</span>
                <span class="time-title">活动时间：</span>
                <span class="time-text">{{ '2026年8月19日 至 2026年8月31日 23:59:59' }}</span>
            </div>
            <!-- 5. 活动声明与免责条款 -->
            <div class="rule-section statement-box">
                <div class="section-title warning-title">⚠️ 活动声明</div>
                <ul class="statement-list">
                    <li>
                        <span class="num">1</span>
                        <div class="content">本活动最终解释权归游戏运营方所有。如遇不可抗力或系统异常，运营方有权调整、延长或提前终止活动并提前公告。</div>
                    </li>
                    <li>
                        <span class="num">2</span>
                        <div class="content"><b>鹊舞签</b>为本次活动专属准入道具，活动结束后未消耗的鹊舞签将不予保留。</div>
                    </li>
                    <li>
                        <span class="num">3</span>
                        <div class="content"><b>情侣红心</b>为经验值型代币，仅限活动期间用于情侣等级提升及排行榜排序，不可扣除、不可兑换、不可转赠。</div>
                    </li>
                    <li>
                        <span class="num">4</span>
                        <div class="content"><b>缘分币</b>为本次活动专属兑换代币，仅限活动期间在兑换商店使用，活动结束后未消耗的缘分币将自动清零，不予折算或返还。</div>
                    </li>
                    <li>
                        <span class="num">5</span>
                        <div class="content">抽奖概率及保底规则已在活动页面公示，参与即视为已阅读并同意。因个人操作失误导致的损失不予补发。</div>
                    </li>
                    <li>
                        <span class="num">6</span>
                        <div class="content">累计奖励将于达标后自动解锁领取。定制歌曲、服饰定制、戒指定制等服务类奖励按约定周期交付。</div>
                    </li>
                    <li>
                        <span class="num">7</span>
                        <div class="content">严禁使用脚本、外挂、第三方工具或其他作弊手段参与活动。一经查实，运营方有权取消获奖资格、追回已发放奖励，并视情节采取封禁处理。</div>
                    </li>
                    <li>
                        <span class="num">8</span>
                        <div class="content">活动期间如对奖励发放有疑问，请在活动结束后 <b>7 日内</b>联系客服核实，逾期不再受理。</div>
                    </li>
                    <li>
                        <span class="num">9</span>
                        <div class="content">充值消费请理性参与，未成年人请在监护人指导下进行操作。</div>
                    </li>
                </ul>
            </div>

              <!-- 4. 概率公示 -->
            <div class="rule-section">
                <div class="section-title">奖池结构及基础概率</div>
                <div class="probability-table">
                    <div class="tr th">
                        <span>等级</span>
                        <span>奖励内容</span>
                        <span>基础概率</span>
                    </div>
                    <div class="tr"><span>S级</span><span>【粉冠之誓】礼盒（绝版）×1</span><span class="highlight">0.05%</span></div>
                    <div class="tr"><span>A级</span><span>七夕专属戒指兑换凭证 ×1</span><span class="highlight">0.45%</span></div>
                    <div class="tr"><span>B级</span><span>七夕专属套装兑换凭证 ×1</span><span>1.50%</span></div>
                    <div class="tr"><span>C级</span><span>情侣戒指/个性戒指/闺蜜戒指 ×1</span><span>2.00%</span></div>
                    <div class="tr"><span>D级</span><span>缘分币 ×500</span><span>14.00%</span></div>
                    <div class="tr"><span>E级</span><span>缘分币 ×200</span><span>27.00%</span></div>
                    <div class="tr"><span>F级</span><span>缘分币 ×50 + 泡点 ×9999</span><span>55.00%</span></div>
                </div>
            </div>


              <!-- 3. 排行榜奖励说明 -->
            <div class="rule-section">
                <div class="section-title">排行榜奖励说明</div>
                <ul class="rule-list">
                    <li>
                        <span class="num">1</span>
                        <div class="content">排行榜分为<b>情侣排行</b>和<b>闺蜜排行</b>，排行依据为活动期间通过七夕相关活动累计获得的情侣红心或蜜糖之心数量（不包含泡点兑换，历史情侣红心或蜜糖之心数据）。</div>
                    </li>
                    <li>
                        <span class="num">2</span>
                        <div class="content">活动结束后，排行前十的情侣或闺蜜可获得七夕限定称号；<b>两榜第1名</b>额外获得全服唯一七夕特权称号。</div>
                    </li>
                    <li>
                        <span class="num">3</span>
                        <div class="content">两榜前三名可获得<b>歌曲定制权</b>（定制数量 = 活动期间消费白金币金额 ÷ 1000 × 5，向下取整）。</div>
                    </li>
                    <li>
                        <span class="num">4</span>
                        <div class="content">两榜第一名还可获得<b>两套服饰定制权</b>（两榜分开计算）及<b>情侣戒指或闺蜜戒指定制一枚</b>。</div>
                    </li>
                </ul>
            </div>

            <!-- 2. 核心规则 -->
            <div class="rule-section">
                <div class="section-title">活动规则</div>
                <ul class="rule-list">
                    <li>
                        <span class="num">1</span>
                        <div class="content">每次开启本次活动奖池<b>消耗2枚鹊舞签</b>，十连抽<b>仅需18枚鹊舞签</b>（ 参与活动时将按白金币—鹊舞签自动兑换，兑换比例为<b>1比1</b> ）。</div>
                    </li>
                    <li>
                        <span class="num">2</span>
                        <div class="content">抽奖所得直接发放至<b>网站商城 — 个人仓库</b>。</div>
                    </li>
                    <li>
                        <span class="num">3</span>
                        <div class="content">
                          S级【粉冠之誓】（绝版）礼盒、A级七夕专属戒指兑换凭证、B级七夕专属套装兑换凭证为兑换凭证形式，可在对应兑换池（抽奖板块下方）自选兑换；C级戒指为<b>9选1随机获取</b>。</div>
                    </li>
                    <li>
                        <span class="num">4</span>
                        <div class="content"><b>累计奖励</b>每种仅限一次，达标自动解锁领取入口，且累计奖励不联动抽奖获得（抽奖获得不占用累计奖励机会）。</div>
                    </li>
                    <li>
                        <span class="num">5</span>
                        <div class="content"><b>缘分币</b>仅限七夕兑换商店使用，不可转赠。商店提供七夕单品、饰品、特色戒指、首饰盒等兑换；动态表情不放入兑换商店。</div>
                    </li>
                    <li>
                        <span class="num">6</span>
                        <div class="content"><b>动态表情</b>仅能通过抽奖奖池和累计奖励（<b>120抽自选1个</b>）获取。</div>
                    </li>
                    <li>
                        <span class="num">7</span>
                        <div class="content">七夕签到活动分<b>情侣模式</b>和<b>闺蜜模式</b>，请确认没有情侣和闺蜜参与签到则无法获得情侣红心或者蜜糖之心奖励；</div>
                    </li>
                    <li>
                        <span class="num">8</span>
                        <div class="content">七夕当日签到可获得<b>新款情侣证书</b>，必须具备情侣关系方可获得；签到累计奖励详见活动页（补签需要支付白金币）；</div>
                    </li>
                    <li>
                        <span class="num">9</span>
                        <div class="content">活动期间获得的<b>情侣红心和蜜糖之心</b>将累加计入游戏相关情侣和闺蜜数据；</div>
                    </li>
                    <li>
                        <span class="num">10</span>
                        <div class="content">定制歌曲、服饰定制、戒指定制等服务类奖励走<b>工单流程</b>，具体规则<b>以商店说明为准</b>。</div>
                    </li>
                </ul>
            </div>


        </div>
        <!-- 抽奖奖励 -->
        <div class="Reward" v-if="seeType == 'Reward'">
            <div class="item" v-for="(value, index) in seeData.allRewards" :key="index">

                <img class="RewardImg" :src="value.itemImg || value.imageUrl" alt="">
                <p :style="{ 'color': value.color }">{{ value.name }}X{{ value.quantity }}</p>

            </div>
            <div class="btn">
                <img src="@/assets/imgs/Qixi/oneExtract.png" @click="() => {
                    $emit('seeReward', 'one')
                    // seeType = 'tishi'
                    // seeData ={type:'one'}
                }" alt="" />
                <img src="@/assets/imgs/Qixi/tenExtract.png" alt="" @click="() => {
                    $emit('seeReward', 'ten')
                }" />
            </div>
        </div>
        <!-- 商城兑换 -->
        <div class="Shop p" v-if="seeType == 'Shop'">
            <div class="items">
                <div class="tit">您确定要兑换 <span>{{ seeData.itemName }}</span> 吗</div>
                <img :src="seeData.itemImg" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <div class="Shophit">本次操作不可逆</div>
            </div>
            <div class="ShopBtn">
                <div class="ShopConfirm" @click="() => {
                    $emit('seeConfirm', { data: seeData, type: 'shop' })
                }">确认</div>
                <div class="ShopClosed" @click="() => {
                    $emit('closeModal')
                }">取消</div>
            </div>
        </div>
        <!-- 追加奖励选择 -->
        <div class="RewardSelection p" v-if="seeType == 'RewardSelection'">
            <div class="items" v-for="(value, index) in seeData.rewardList" :key="index"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                    <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                </div>
                <img :src="value.itemImg" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <p>{{ value.name }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn" :class="{ 'disabled': !selectedItem }" @click="() => {
                    $emit('seeConfirm', { data: selectedItem, seeData: seeData, type: 'RewardSelection' })
                }">确定</div>
            </div>
        </div>
        <div class="hit" v-if="seeType == 'RewardSelection'">点击选择心仪的商品</div>

        <!-- 兑换奖励选择 -->
        <div class="RewardSelection p" v-if="seeType == 'ExchangeRewards'">
            <div class="items" v-for="(value, index) in seeData.rewardList" :key="index"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                    <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                </div>
                <img :src="value.itemImg" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <p>{{ value.name || value.bundleName }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn" :class="{ 'disabled': !selectedItem }" @click="ExchangeRewardsFun(selectedItem)">确定
                </div>
            </div>
        </div>
        <div class="hit" v-if="seeType == 'ExchangeRewards'">
            累计数量:( {{ seeData.totalNum }} )，
            剩余数量:( {{ seeData.availableNum }} )，
            已使用数量:( {{ seeData.usedNum }} )
        </div>
        <!-- 兑换全勤奖励 -->
        <div class="RewardSelection p" v-if="seeType == 'FullAttendance'">
            <div class="items" v-for="(value, index) in seeData.list" :key="index"
                :class="{ 'selected': selectedItem === value }" @click="selectItem(value)">
                <div class="sex">
                    <img v-if="value.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                    <img v-else-if="value.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                    <img v-else-if="value.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                    <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                </div>
                <img :src="value.itemImg || value.imageUrl" alt="">
                <!-- <img src="https://download-wx.qtthtech.com/shop/item/0/5002.png" alt=""> -->
                <p>{{ value.name || value.bundleName }}</p>
            </div>
            <div class="RewardSelection">
                <div class="btn" :class="{ 'disabled': !selectedItem }" @click="FullAttendanceFun(selectedItem)">确定
                </div>
            </div>
        </div>
        <!-- 兑换 -->
        <div class="Exchange p" v-if="seeType == 'Exchange'">
            <p class="hint">鹊舞签不足，需要使用1个白金币兑换1个鹊舞签？</p>
            <!-- 兑换图展示 -->
            <div class="conversion_img">
                <img src="@/assets/imgs/chidrenDay/gold.png" alt="">
                <p>1:1</p>
                <img src="@/assets/imgs/chidrenDay/zhu.png" alt="">
            </div>
            <!-- 兑换 -->
            <div class="conversion_input">
                <span>兑换 :</span>
                <input type="text" v-model="conversion_number"
                    @input="conversion_number = conversion_number.replace(/[^\d]/g, '').replace(/^0+/, '')">
            </div>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="ExchangeLotteryCurrencyConfirmFun">确认</div>
            </div>

            <div class="CurrencySurplus">
                白金币剩余：{{ seeData.drawTokenBalance }}
            </div>
        </div>
        <!-- 跳转充值页面 -->
        <div class="goRecharge p" v-if="seeType == 'goRecharge'">
            <p class="hint">您当前白金币不足，是否跳转充值页面？</p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="goRechargeConfirmFun">确认</div>
            </div>
        </div>
        <!-- 抽奖提示 -->
        <div class="tishi p" v-if="seeType == 'tishi'">
            <p class="hint">确定支付吗</p>
            <p class="hint">本次消耗：{{ seeData.type == 'one' ? '2' : '18' }}鹊舞签</p>
            <p class="hint">确定支付后将为您
                <span style="color: red;font-size: 20px;font-weight: 700;">1：1</span>
                兑换：白金币 - 鹊舞签
            </p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="tishiConfirmFun">确认</div>
            </div>
        </div>
        <!-- 补签提示 -->
        <div class="tishi p" v-if="seeType == 'buqian'">
            <p class="hint">确定补签吗</p>
            <p class="hint">本次消耗：20白金币</p>
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="buqianConfirmFun">确认</div>
            </div>
        </div>
        <!-- 奖池预览 -->
        <div class="PrizePool p" v-if="seeType == 'PrizePool'">
            <div class="hint-title">
                <span>当前奖池预览</span>
            </div>

            <div class="items">
                <div :class="['item', item.obtained ? 'obtained' : '']" v-for="(item, index) in seeData" :key="index">
                    <!-- 稀有度角标/背光 -->
                    <div class="card-glow"></div>

                    <!-- 性别标识 -->
                    <div class="sex" v-if="item.sex">
                        <img v-if="item.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                        <img v-else-if="item.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                        <img v-else-if="item.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                        <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                    </div>

                    <!-- 道具展示框（加底座感） -->
                    <div class="img-wrapper">
                        <img class="prize_img" :src="item.itemImg" :alt="item.itemName" />
                    </div>

                    <!-- 道具名称及数量 -->
                    <div class="name-box">
                        <p class="name" :style="{ color: item.color || '#ffffff' }">
                            {{ item.level }} {{ item.name || item.bundleName }}
                        </p>
                        <span class="num-tag" v-if="item.quantity > 1">×{{ item.quantity }}</span>
                    </div>

                    <img v-if="item.obtained" class="Obtain" src="@/assets/imgs/Qingliang_yixia/sign_in_ok.png" alt="">

                </div>
            </div>
        </div>
        <!-- 兑换奖励预览 -->
        <div class="PrizePool p" v-if="seeType == 'SeeExchangeRewards'">
            <div class="hint-title">
                <span>{{ seeData.level }}</span>
            </div>

            <div class="items">
                <div class="item" v-for="(item, index) in seeData.allRewards" :key="index">
                    <!-- 稀有度角标/背光 -->
                    <div class="card-glow"></div>

                    <!-- 性别标识 -->
                    <div class="sex" v-if="item.sex">
                        <img v-if="item.sex == 1" src="@/assets/imgs/chidrenDay/userSex1.png" alt="" />
                        <img v-else-if="item.sex == 2" src="@/assets/imgs/chidrenDay/userSex2.png" alt="" />
                        <img v-else-if="item.sex == 3" src="@/assets/imgs/chidrenDay/userSex3.png" alt="" />
                        <img v-else src="@/assets/imgs/chidrenDay/userSex4.png" alt="" />
                    </div>

                    <!-- 道具展示框（加底座感） -->
                    <div class="img-wrapper">
                        <img class="prize_img" :src="item.itemImg" :alt="item.itemName" />
                    </div>

                    <!-- 道具名称及数量 -->
                    <div class="name-box">
                        <p class="name" :style="{ color: item.color || '#ffffff' }">
                            {{ item.name }}
                        </p>
                        <span class="num-tag" v-if="item.quantity > 1">×{{ item.quantity }}</span>
                    </div>

                    <img v-if="item.obtained" class="Obtain" src="@/assets/imgs/Qingliang_yixia/sign_in_ok.png" alt="">

                </div>
            </div>
        </div>

        <!-- 心直购  提示-->
        <div class="directPurchasing p" v-if="seeType == 'directPurchasing'">
            <p class="hint">确定要使用{{ seeData.price }}白金币直接购买{{ seeData.name }}吗？</p>
            <p class="hint">当前礼包价值：{{ seeData.heartNum }}{{ seeData.heartName }}</p>
            <p class="hint">确认后将无法取消，请谨慎操作</p>
            <img class="Gift" v-if="seeData.packageId == 1" src="@/assets/imgs/Qixi/directPurchasing/1.png" alt="">
            <img class="Gift" v-else-if="seeData.packageId == 2" src="@/assets/imgs/Qixi/directPurchasing/2.png" alt="">
            <img class="Gift" v-else src="@/assets/imgs/Qixi/directPurchasing/3.png" alt="">
            <div class="ConfirmExchange">
                <div class="ShopConfirm" @click="directPurchasingConfirmFun">确认</div>
            </div>

            <div class="CurrencySurplus">
                白金币剩余：{{ seeData.drawTokenBalance }}
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Cookies from "js-cookie";
export default {
    props: {
        seeType: String,
        seeData: { type: [Object, Array] },
    },
    data() {
        return {
            infoData: [],
            total: 0,
            selectedItem: null,
            conversion_number: 1,
            loading: null,
            modeType: 'COUPLE',
            rankList: [],
            RecordList: [],
        }
    },
    mounted() {
        if (this.seeType == 'Record') {
            this.RecordFun(1)
        } else if (this.seeType == 'Ranking') {
            this.RankingFun()
        }

    },
    methods: {

        // 切换产看记录
        pagination_change(e) {
            // this.RecordFun(e)
            this.RecordFun(e)

        },
        RecordFun(pageNum) {
            axios({
                method: "post",
                url: "/activityV2/getDrawRecords",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    pageNum,
                    pageSize: 10,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) { 
                        const list = res.data.data.list;

                        this.RecordList = list.flatMap(item => {
                            const currentLevel = item.level;

                            // 核心逻辑：优先取 rewards，如果没有或为空，则尝试取 voucher
                            // 注意：voucher 是对象，必须用 [] 包裹成数组才能使用 .map()
                            const sourceList = (item.rewards && item.rewards.length > 0)
                                ? item.rewards
                                : (item.voucher ? [item.voucher] : []);

                            return sourceList.map(reward => ({
                                ...reward,        // 保留原有的 itemImg, quantity, name 等数据
                                level: currentLevel // 注入层级信息
                            }));
                        });
                        this.total = res.data.data.total
                        // this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        RankingFun() {
            axios({
                method: "post",
                url: "/activityV2/getHeartRank",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.infoData = res.data.data
                        // this.$message.success(res.data.message);
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                });
        },
        selectItem(item) {
            this.selectedItem = item;
        },
        ExchangeLotteryCurrencyConfirmFun() {
            if (this.conversion_number > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                axios({
                    method: "post",
                    url: "/pieceLotteryV2/exchangeCoin",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        exchangeNum: this.conversion_number,
                        drawTokenCode: 'piece_draw_202608_1',
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    });
            }
        },
        // 兑换奖励
        ExchangeRewardsFun(item) { 
            this.loading = this.$loading({
                // lock: true,
                text: '兑换中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/exchangeVoucher",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    level: this.seeData.level,
                    rewardNo: item.rewardNo,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.$message.success(res.data.message)
                        this.$emit('seeConfirm', { type: 'Exchange' })
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading.close();
                });

        },
        //全勤奖励领取
        FullAttendanceFun() { 
            this.loading = this.$loading({
                // lock: true,
                text: '领取中....',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                method: "post",
                url: "/activityV2/claimAttendanceReward",
                headers: {
                    token: Cookies.get("wx_token"),
                },
                data: {
                    signMode: this.seeData.signMode,
                    userId: Cookies.get("wx_userId"), // userId
                    platForm: "web",
                },
            })
                .then((res) => {
                    if (res.data.state == 200) {
                        this.$message.success(res.data.message)
                        this.$emit('seeConfirm', { type: 'Exchange' })
                    } else {
                        this.$message.error(res.data.message);
                    }
                })
                .catch((err) => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading.close();
                });
        },

        // 心直购兑换
        directPurchasingConfirmFun() { 
            if (this.seeData.price > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                this.loading = this.$loading({
                    // lock: true,
                    text: '领取中....',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios({
                    method: "post",
                    url: "/activityV2/buyHeartPackage",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        packageId: this.seeData.packageId,
                        signMode: this.seeData.signMode,
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading.close();
                    });
            }
        },

        // 补签确认
        buqianConfirmFun() {
            if (20 > this.seeData.drawTokenBalance) {
                this.$message.info('白金币不足！！！')
            } else {
                this.loading = this.$loading({
                    // lock: true,
                    text: '补签中....',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                axios({
                    method: "post",
                    url: "/activityV2/makeupSign",
                    headers: {
                        token: Cookies.get("wx_token"),
                    },
                    data: {
                        dayNo: this.seeData.dayNo,
                        signMode: this.seeData.signMode,
                        userId: Cookies.get("wx_userId"), // userId
                        platForm: "web",
                    },
                })
                    .then((res) => {
                        if (res.data.state == 200) {
                            this.$message.success(res.data.message)
                            this.$emit('seeConfirm', { type: 'Exchange' })
                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                    .catch((err) => {
                        this.$message.error(err.message);
                    }).finally(() => {
                        this.loading.close();
                    });
            }
        },



        tishiConfirmFun() {
            if (this.seeData.type == 'one') {
                this.$emit('seeReward', 'one')
            } else {
                this.$emit('seeReward', 'ten')
            }
        },
        // confirmSelection() {
        //     if (this.selectedItem) {
        //         console.log('选中的信息:', this.selectedItem);
        //         this.$emit('selectReward', this.selectedItem);
        //     }
        // }
        // 跳转充值页面
        goRechargeConfirmFun() {
            this.$router.push({ path: '/Recharge' })
        },
        // 切换模式
        // 切换模式
        switchMode(mode) {
            if (mode == 'COUPLE') {
                this.rankList = this.infoData.coupleRank.rankList
            } else {
                this.rankList = this.infoData.sisterRank.rankList
            }
            this.modeType = mode
        }
    }
}

</script>

<style lang="less" scoped>
.RewardModal {
    // width: 40vw !important;
    height: 400px !important;
}

.borderModal {
    position: relative;
    text-align: center;
    width: 30vw;
    min-width: 600px;
    // height: 100%;
    height: 70vh;
    min-height: 450px;
    border-radius: 10px;
    padding: 5px;

    background-image: url('../../../assets/imgs/Qixi/TC_Bg.png');

    /* 关键属性：确保图片铺满整个容器，不重复，且保持比例 */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;



    .closed {
        position: absolute;
        top: -50px;
        right: -50px;
        cursor: pointer;
        z-index: 10;
    }

    .bg {
        width: 100%;
        height: 110%;
        max-height: 800px;
    }

    .p {
        position: absolute;
        top: 35px;
        width: 92%;
        height: 88%;
        left: 50%;
        transform: translateX(-50%);
        overflow: auto;
    }

    .RankBody {
        top: 65px;
        overflow: visible !important;
        position: relative;

        .signIn_mode {
            position: absolute;
            left: -15px;
            top: -65px;
            display: flex;
            gap: 12px;

            z-index: 20;

            .mode_item {
                position: relative;

                height: 32px;
                padding: 0 14px;

                display: flex;
                align-items: center;
                gap: 6px;

                color: #8253f6;

                font-size: 13px;
                font-weight: bold;

                background: rgba(255, 255, 255, .9);

                border: 1px solid #bd25b8;
                border-radius: 18px;

                cursor: pointer;

                transition: .2s;

                &.active {
                    color: #fff;

                    background: #8253f6;

                    box-shadow: 0 2px 5px rgba(189, 37, 184, .25);
                }
            }
        }

        .tit {
            width: 100%;
            display: flex;
            margin-bottom: 20px;

            >div {
                flex: 1;
                font-size: 17px;
                font-weight: 800;
                color: #fff;
                user-select: none;
                text-shadow:
                    /* 左上角投影 */
                    -1px -1px 0 #8253f6,
                    /* 右上角投影 */
                    1px -1px 0 #8253f6,
                    /* 左下角投影 */
                    -1px 1px 0 #8253f6,
                    /* 右下角投影 */
                    1px 1px 0 #8253f6;
            }
        }

        .items {
            width: 100%;
            height: 93%;
            overflow-y: auto;
            margin: auto;

            .itemList {
                width: 100%;
                height: 30px;
                line-height: 30px;
                display: flex;
                margin-bottom: 20px;

                >div {
                    height: 100%;
                    flex: 1;
                    font-size: 18px;
                    font-weight: 700;
                    color: #fff;
                    user-select: none;
                    text-wrap: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-shadow:
                        /* 左上角投影 */
                        -1px -1px 0 #8253f6,
                        /* 右上角投影 */
                        1px -1px 0 #8253f6,
                        /* 左下角投影 */
                        -1px 1px 0 #8253f6,
                        /* 右下角投影 */
                        1px 1px 0 #8253f6;
                }

            }
        }
    }

    // 记录
    .Record {
        overflow: hidden;
        display: flex;
        flex-direction: column;

        .tit {
            width: 100%;
            display: flex;
            margin-bottom: 20px;

            >div {
                flex: 1;
                font-size: 17px;
                font-weight: 800;
                color: #fff;
                user-select: none;
                text-shadow:
                    /* 左上角投影 */
                    -1px -1px 0 #8253f6,
                    /* 右上角投影 */
                    1px -1px 0 #8253f6,
                    /* 左下角投影 */
                    -1px 1px 0 #8253f6,
                    /* 右下角投影 */
                    1px 1px 0 #8253f6;
            }
        }

        .items {
            width: 96%;
            height: 88%;
            overflow-y: auto;
            margin: auto;

            .itemList {
                width: 100%;
                height: 30px;
                line-height: 30px;
                display: flex;
                margin-bottom: 20px;

                >div {
                    height: 100%;
                    flex: 1;
                    font-size: 18px;
                    font-weight: 700;
                    color: #fff;
                    user-select: none;
                    text-wrap: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    text-shadow:
                        /* 左上角投影 */
                        -1px -1px 0 #8253f6,
                        /* 右上角投影 */
                        1px -1px 0 #8253f6,
                        /* 左下角投影 */
                        -1px 1px 0 #8253f6,
                        /* 右下角投影 */
                        1px 1px 0 #8253f6;
                }

            }
        }

        .Record_btn {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    //规则
    .Rules {
        width: 100%;
        max-width: 800px;
        margin: 0 auto;
        padding: 10px 5px;
        box-sizing: border-box;
        color: #ffffff;

        /* 1. 活动时间卡片（优化渐变与柔和度） */
        .time-card {
            background: linear-gradient(135deg, #e8ddff 0%, #fbe4ff 100%);
            /* 融入七夕粉紫浪漫渐变 */
            border-left: 4px solid #9b61ff;
            /* 换成配套的紫色边框 */
            border-radius: 8px;
            padding: 10px 16px;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: bold;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

            .clock-icon {
                margin-right: 6px;
                font-size: 16px;
            }

            .time-title {
                color: #6b3ba7;
                /* 深紫灰色，提升浅色背景上的对比度和质感 */
                margin-right: 4px;
            }

            .time-text {
                color: #2c233d;
                /* 暗紫黑，确保文本清晰易读 */
                font-weight: bold;
            }
        }

        /* 2. 通用板块样式 */
        .rule-section {
            background: rgba(85, 78, 128, 0.65);
            /* 略微微调背景紫调，更显质感 */
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 12px;
            padding: 16px 18px;
            margin-bottom: 16px;
            backdrop-filter: blur(8px);
            text-align: left;

            .section-title {
                font-size: 16px;
                font-weight: bold;
                color: #e5d8ff;
                margin-bottom: 14px;
                display: flex;
                align-items: center;
                letter-spacing: 0.5px;
                text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);

                &::before {
                    content: '';
                    display: inline-block;
                    width: 4px;
                    height: 16px;
                    background: #c19bfb;
                    margin-right: 8px;
                    border-radius: 2px;
                }
            }
        }

        /* 3. 核心规则列表 */
        .rule-list {
            list-style: none;
            padding: 0;
            margin: 0;

            li {
                font-size: 13px;
                line-height: 1.6;
                margin-bottom: 10px;
                display: flex;
                align-items: flex-start;
                color: #ffffff;

                &:last-child {
                    margin-bottom: 0;
                }

                b {
                    color: #ffe600;
                    /* 高亮关键字黄字 */
                    font-weight: bold;
                }

                .num {
                    background: #8751db;
                    /* 调整为紫色编号标，与全局主题统一 */
                    color: #ffffff;
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 11px;
                    font-weight: bold;
                    margin-right: 8px;
                    flex-shrink: 0;
                    margin-top: 2px;
                }

                .content {
                    flex: 1;
                    text-align: left;
                }
            }
        }

        /* 4. 概率表格（优化多列比例） */
        .probability-table {
            width: 100%;
            max-width: 100%;
            margin: 8px auto;
            border: 1px solid rgba(255, 255, 255, 0.25);
            border-radius: 8px;
            overflow: hidden;

            .tr {
                display: flex;
                border-bottom: 1px solid rgba(255, 255, 255, 0.15);
                font-size: 13px;

                &:last-child {
                    border-bottom: none;
                }

                /* 分配三列比例：第1列(等级)占15%，第2列(奖励内容)占60%，第3列(概率)占25% */
                span {
                    padding: 8px 10px;
                    text-align: center;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &:nth-child(1) {
                        flex: 0 0 15%;
                    }

                    &:nth-child(2) {
                        flex: 0 0 50%;
                        // justify-content: flex-start;
                        /* 奖励名称左对齐，阅读更舒适 */
                        text-align: center;
                    }

                    &:nth-child(3) {
                        flex: 0 0 25%;
                    }

                    &.highlight {
                        color: #ffe600;
                        font-weight: bold;
                    }
                }

                &.th {
                    background: rgba(118, 77, 185, 0.6);
                    /* 改为统一紫调表头 */
                    font-weight: bold;

                    span {
                        color: #ffffff;
                        justify-content: center;
                        /* 表头统一居中 */
                        text-align: center;
                    }
                }
            }
        }

        /* 5. 声明板块 */
        .statement-box {
            .warning-title {
                color: #ffd8d8;
                /* 声明标题微调为暖柔色，起到警示又不过于突兀的作用 */

                &::before {
                    background: #c19bfb;
                }
            }

            .statement-list {
                list-style: none;
                padding: 0;
                margin: 0;

                li {
                    font-size: 13px;
                    line-height: 1.6;
                    color: #ffffff;
                    margin-bottom: 10px;
                    display: flex;
                    align-items: flex-start;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    b {
                        color: #ffe600;
                    }

                    .num {
                        background: #8751db;
                        color: #ffffff;
                        border: 1px solid rgba(255, 255, 255, 0.4);
                        width: 18px;
                        height: 18px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 11px;
                        font-weight: bold;
                        margin-right: 8px;
                        flex-shrink: 0;
                        margin-top: 2px;
                    }

                    .content {
                        flex: 1;
                        text-align: left;
                    }
                }
            }
        }
    }

    // 抽奖奖励
    .Reward {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        .item {
            width: 20%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 10px;

            .RewardImg {
                max-width: 70%;
            }
        }

        .btn {
            width: 100%;

            img {
                width: 30%;
                cursor: pointer;
            }
        }
    }

    // 商城兑换
    .Shop {
        .items {
            width: 100%;
            height: 70%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .tit {
                font-size: 2rem;

                span {
                    color: red;
                    font-size: 2.3rem;
                }
            }

            >img {
                max-width: 30%;
                max-height: 60%;
                margin: 20px 0px;

                .Shophit {
                    font-size: 1.5rem;
                }
            }
        }

        .ShopBtn {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            >div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
            }

            .ShopConfirm {

                background: repeating-linear-gradient(to left, #8253f6, #8253f6, #8253f6);
                color: #fff;
            }

            .ShopClosed {
                background-color: rgb(255, 255, 255);
                color: #8253f6;
            }
        }
    }

    // 追加奖励选择
    .RewardSelection {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px 10px;
        align-items: center;

        .items {
            width: 19%;
            max-height: 220px;
            padding: 10px;
            display: flex;
            background-color: #ffffff57;
            border-radius: 20px;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            cursor: pointer;
            border: 2px solid #ffffff57;
            gap: 20px;

            .sex {
                width: 100%;
                height: 10%;
                text-align: left;

                >img {
                    max-width: 28px;
                }
            }

            img {
                max-width: 60px;
            }
        }

        .items:hover {
            background-color: #f19ef2;
            color: #fff;
        }

        .items.selected {
            background-color: #f19ef2;
            color: #fff;
            border: 2px solid #ff69b4;
        }

        .RewardSelection {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, rgb(252, 162, 242), rgb(235, 151, 249), rgb(255, 163, 240));
                color: rgb(255, 255, 255);
            }

            .btn.disabled {
                background: #ccc;
                cursor: not-allowed;
                color: #999;
            }
        }
    }

    // 兑换
    .Exchange {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
        }

        .conversion_img {
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 20px 0;

            >img {
                max-height: 80px;
            }

            >p {
                font-size: 50px;
                font-weight: 600;
                margin: 0 50px;
                color: #fff;
                font-family: Verdana, Geneva, Tahoma, sans-serif;
                text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
            }
        }

        .conversion_input {
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            left: -5%;

            span {
                font-size: 24px;
                margin-right: 30px;
                color: #fff;
                font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
                text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;

            }

            input {
                line-height: 40px;
                border-radius: 20px;
                text-align: center;
                font-size: 20px;
                background-color: #fff;
                border: 1px solid #ff1973ff;
                color: #ff1973ff;
            }

            input:focus {
                outline: 2px solid #fce18d;
                border: 1px solid #fce18d;

                /* 获得焦点时显示绿色轮廓 */
            }

        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, rgb(252, 162, 242), rgb(235, 151, 249), rgb(255, 163, 240));
                color: rgb(255, 255, 255);
                box-shadow: 0 0 8px #ff1973ff;
            }

            .ShopConfirm:hover {
                background: #ff197382;
            }
        }

        .CurrencySurplus {
            padding: 20px;
            background-color: #ff197382;
            border-radius: 20px;
            font-size: 20px;
            color: #fff;
            font-weight: 700;
        }
    }

    // 跳转充值页面
    .goRecharge {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #8253f6, 1px -1px 0 #8253f6, -1px 1px 0 #8253f6, 1px 1px 0 #8253f6;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: repeating-linear-gradient(to left, #8253f6, #8253f6, #8253f6);
                color: #fff;
                box-shadow: 0 0 8px #8253f6;
            }

            .ShopConfirm:hover {
                background: rgb(93, 162, 226);
            }
        }
    }


    // 抽奖提示
    .tishi {
        height: 90%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        gap: 20px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: linear-gradient(90deg, #ff69b4 0%, #af25ad 100%);
                color: #fff;
                box-shadow: 0 4px 15px rgba(175, 37, 173, 0.4);
            }

            .ShopConfirm:hover {
                background-position: right center;
                /* 触发背景移动 */
                transform: translateY(-2px) scale(1.05);
                /* 微微上浮并放大 */
                box-shadow: 0 6px 20px rgba(255, 105, 180, 0.7);
                /* 光晕变亮变大 */
            }
        }
    }

    // 奖池预览
    .PrizePool {
        padding: 10px;

        /* 标题提升：加金属光泽感与底纹 */
        .hint-title {
            text-align: center;
            margin-bottom: 15px;

            span {
                font-size: 20px;
                font-weight: 800;
                letter-spacing: 1px;
                background: linear-gradient(180deg, #FFFFFF 0%, #BFE3FF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                /* 优雅的模糊阴影替代硬粗描边 */
                filter: drop-shadow(0 2px 4px rgba(0, 80, 180, 0.8));
            }
        }

        .items {
            display: flex;
            flex-wrap: wrap;
            gap: 12px 10px;
            justify-content: flex-start;
            padding: 5px;

            .item {
                position: relative;
                width: 31%; // 保持 3 列布局
                min-width: 95px;
                height: 170px;
                /* 固定高度确保对齐美观 */
                padding: 8px 6px;
                box-sizing: border-box;

                /* 玻璃拟态与渐变微光 */
                background: linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                backdrop-filter: blur(8px);
                border-radius: 14px;
                border: 1px solid rgba(255, 255, 255, 0.4);
                box-shadow: 0 4px 12px rgba(0, 30, 80, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.5);

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;
                transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

                /* 悬浮动效：微抬 + 亮光 + 边框高亮 */
                &:hover {
                    transform: translateY(-4px) scale(1.02);
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.38) 0%, rgba(255, 255, 255, 0.15) 100%);
                    border-color: rgba(255, 255, 255, 0.8);
                    box-shadow: 0 8px 20px rgba(0, 100, 220, 0.3), inset 0 0 10px rgba(255, 255, 255, 0.6);

                    .prize_img {
                        transform: scale(1.1);
                    }
                }

                /* --- 稀有度颜色扩展 (可以在数据 item.quality 配置 'gold' | 'purple' | 'blue') --- */
                &.gold {
                    border-color: rgba(255, 215, 0, 0.6);
                    background: linear-gradient(135deg, rgba(255, 215, 0, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                }

                &.purple {
                    border-color: rgba(200, 120, 255, 0.6);
                    background: linear-gradient(135deg, rgba(180, 90, 255, 0.25) 0%, rgba(255, 255, 255, 0.08) 100%);
                }

                /* 性别角标优化 */
                .sex {
                    position: absolute;
                    top: 4px;
                    left: 6px;
                    z-index: 2;

                    img {
                        width: 35px;
                        height: 35px;
                        object-fit: contain;
                        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
                    }
                }

                /* 道具图片展示盒（加发光底座） */
                .img-wrapper {
                    position: relative;
                    width: 100%;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    /* 道具下方微弱圆形高光底座 */
                    &::after {
                        content: '';
                        position: absolute;
                        width: 40px;
                        height: 12px;
                        bottom: 2px;
                        background: radial-gradient(ellipse at center, rgba(255, 255, 255, 0.6) 0%, rgba(255, 255, 255, 0) 70%);
                        border-radius: 50%;
                        pointer-events: none;
                    }

                    .prize_img {
                        max-width: 100px;
                        max-height: 100px;
                        object-fit: contain;
                        filter: drop-shadow(0 4px 6px rgba(0, 20, 50, 0.3));
                        transition: transform 0.3s ease;
                    }
                }

                /* 道具名字与数量盒子 */
                .name-box {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    z-index: 2;

                    .name {
                        width: 100%;
                        font-size: 12px;
                        font-weight: 700;
                        text-align: center;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        /* 超出省略号，防止换行丑陋 */
                        line-height: 1.2;
                        margin: 0;
                        /* 换用软核阴影，抛弃黏糊的硬描边 */
                        text-shadow: 0 1px 3px rgb(23, 6, 255);
                    }

                    /* 数量变成精致的小气泡 */
                    .num-tag {
                        font-size: 11px;
                        font-weight: 800;
                        color: #FFE600;
                        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
                        margin-top: 1px;
                    }
                }

                .Obtain {
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    width: 40%;
                    z-index: 2;
                }
            }

            .obtained {
                filter: grayscale(100%);
            }

        }

    }

    // 心直购  提示
    .directPurchasing {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        z-index: 1000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 30px;

        .hint {
            font-size: 20px;
            color: #fff;
            font-weight: 700;
            text-shadow: -1px -1px 0 #ff1973ff, 1px -1px 0 #ff1973ff, -1px 1px 0 #ff1973ff, 1px 1px 0 #ff1973ff;
        }

        .Gift {
            width: 30%;
        }

        .ConfirmExchange {
            display: flex;
            justify-content: center;
            gap: 40px;
            margin-top: 20px;

            div {
                border-width: medium;
                border-style: none;
                border-color: currentcolor;
                border-image: initial;
                font-size: 24px;
                width: 150px;
                height: 50px;
                line-height: 50px;
                border-radius: 25px;
                cursor: pointer;
                background: linear-gradient(90deg, #ff69b4 0%, #af25ad 100%);
                color: #fff;
                box-shadow: 0 4px 15px rgba(175, 37, 173, 0.4);
            }

            .ShopConfirm:hover {
                background-position: right center;
                /* 触发背景移动 */
                transform: translateY(-2px) scale(1.05);
                /* 微微上浮并放大 */
                box-shadow: 0 6px 20px rgba(255, 105, 180, 0.7);
                /* 光晕变亮变大 */
            }
        }

        .CurrencySurplus {
            padding: 20px;
            background-color: #ff197382;
            border-radius: 20px;
            font-size: 20px;
            color: #fff;
            font-weight: 700;
        }
    }


    .hit {
        position: absolute;
        bottom: 0;
        width: 92%;
        left: 50%;
        transform: translateX(-50%);
        float: left;
        margin: 10px 0;
        color: red;
        font-size: 17px;
        text-shadow:
            /* 左上角投影 */
            -1px -1px 0 #ffffff,
            /* 右上角投影 */
            1px -1px 0 #ffffff,
            /* 左下角投影 */
            -1px 1px 0 #ffffff,
            /* 右下角投影 */
            1px 1px 0 #ffffff;
    }
}
</style>